<template>
  <div class="perizinan-container">
    <div class="modal-company-tab-container__btn-wrapper">
      <div
        :class="
          activeSubTab == 'kbli'
            ? 'modal-company-tab-container__btn-detail'
            : 'modal-company-tab-container__btn-detail-not-active'
        "
        @click="setSubTab('kbli')"
      >
        Kegiatan Usaha Utama
      </div>
      <div
        :class="
          activeSubTab == 'iujp'
            ? 'modal-company-tab-container__btn-detail'
            : 'modal-company-tab-container__btn-detail-not-active'
        "
        @click="setSubTab('iujp')"
      >
        IUJP
      </div>
      <div
        :class="
          activeSubTab == 'sbujk'
            ? 'modal-company-tab-container__btn-detail'
            : 'modal-company-tab-container__btn-detail-not-active'
        "
        @click="setSubTab('sbujk')"
      >
        SBUJK
      </div>
      <div
        :class="
          activeSubTab == 'iujptl'
            ? 'modal-company-tab-container__btn-detail'
            : 'modal-company-tab-container__btn-detail-not-active'
        "
        @click="setSubTab('iujptl')"
      >
        IUJPTL
      </div>
      <div
        :class="
          activeSubTab == 'inubbm'
            ? 'modal-company-tab-container__btn-detail'
            : 'modal-company-tab-container__btn-detail-not-active'
        "
        @click="setSubTab('inubbm')"
      >
        INU BBM
      </div>
      <div
        :class="
          activeSubTab == 'siupal'
            ? 'modal-company-tab-container__btn-detail'
            : 'modal-company-tab-container__btn-detail-not-active'
        "
        @click="setSubTab('siupal')"
      >
        SIUPAL
      </div>
    </div>
    <KBLI v-if="activeSubTab == 'kbli'" />
    <IUJP v-if="activeSubTab == 'iujp'" />
    <IUJPTL v-if="activeSubTab == 'iujptl'" />
    <SBUJK v-if="activeSubTab == 'sbujk'" />
    <INUBBM v-if="activeSubTab == 'inubbm'" />
    <SIUPAL v-if="activeSubTab == 'siupal'" />
  </div>
</template>
<script>
export default {
  components: {
    KBLI: () => import('@/components/CompanyInfo/Perizinan/KegiatanUsahaUtama'),
    IUJP: () => import('@/components/CompanyInfo/Perizinan/IUJP'),
    IUJPTL: () => import('@/components/CompanyInfo/Perizinan/IUJPTL'),
    SBUJK: () => import('@/components/CompanyInfo/Perizinan/SBUJK'),
    INUBBM: () => import('@/components/CompanyInfo/Perizinan/INUBBM'),
    SIUPAL: () => import('@/components/CompanyInfo/Perizinan/SIUPAL'),
  },
  data() {
    return {}
  },
  computed: {
    activeSubTab() {
      return this.$store.state.level1.activeSubTab
    },
  },
  created() {},
  methods: {
    setSubTab(value) {
      switch (value) {
        case 'kbli':
          this.$store.commit('level1/GET_KBLI_DATA', value)
          break
        case 'iujp':
          this.$store.commit('level1/GET_IJUP_DATA', value)
          break
        case 'iujptl':
          this.$store.commit('level1/GET_IJUPTL_DATA', value)
          break
        case 'sbujk':
          this.$store.commit('level1/GET_SBUJK_DATA', value)
          break
        case 'inubbm':
          this.$store.commit('level1/GET_INUBBM_DATA', value)
          break
        case 'siupal':
          this.$store.commit('level1/GET_SIUPAL_DATA', value)
          break

        default:
          break
      }
    },
  },
}
</script>
